import React from 'react';

function Microservices(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 553.021 551.489"
            style={{
                transform: "translateZ(50px)"
            }}
            {...props}
        >
            <defs>
                <linearGradient
                    id="microservices__prefix__a"
                    x1={217.097}
                    y1={169.881}
                    x2={334.632}
                    y2={169.881}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#518be6" />
                    <stop offset={1} stopColor="#3e78e6" />
                </linearGradient>
                <linearGradient
                    id="microservices__prefix__b"
                    x1={275.479}
                    y1={223.653}
                    x2={334.632}
                    y2={223.653}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#0a3695" />
                    <stop offset={1} stopColor="#2f62ce" />
                </linearGradient>
                <linearGradient
                    id="microservices__prefix__c"
                    x1={216.52}
                    y1={223.653}
                    x2={276.056}
                    y2={223.653}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#5d7fee" />
                    <stop offset={1} stopColor="#3262d0" />
                </linearGradient>
                <linearGradient
                    id="microservices__prefix__d"
                    x1={380.682}
                    y1={113.539}
                    x2={445.082}
                    y2={113.539}
                    xlinkHref="#microservices__prefix__a"
                />
                <linearGradient
                    id="microservices__prefix__e"
                    x1={412.671}
                    y1={143.002}
                    x2={445.082}
                    y2={143.002}
                    xlinkHref="#microservices__prefix__b"
                />
                <linearGradient
                    id="microservices__prefix__f"
                    x1={380.366}
                    y1={143.002}
                    x2={412.987}
                    y2={143.002}
                    xlinkHref="#microservices__prefix__c"
                />
                <linearGradient
                    id="microservices__prefix__g"
                    x1={106.386}
                    y1={113.539}
                    x2={170.786}
                    y2={113.539}
                    xlinkHref="#microservices__prefix__a"
                />
                <linearGradient
                    id="microservices__prefix__h"
                    x1={138.375}
                    y1={143.002}
                    x2={170.786}
                    y2={143.002}
                    xlinkHref="#microservices__prefix__b"
                />
                <linearGradient
                    id="microservices__prefix__i"
                    x1={106.07}
                    y1={143.002}
                    x2={138.691}
                    y2={143.002}
                    xlinkHref="#microservices__prefix__c"
                />
                <linearGradient
                    id="microservices__prefix__j"
                    x1={381.743}
                    y1={257.288}
                    x2={446.143}
                    y2={257.288}
                    xlinkHref="#microservices__prefix__a"
                />
                <linearGradient
                    id="microservices__prefix__k"
                    x1={413.732}
                    y1={286.75}
                    x2={446.143}
                    y2={286.75}
                    xlinkHref="#microservices__prefix__b"
                />
                <linearGradient
                    id="microservices__prefix__l"
                    x1={381.427}
                    y1={286.75}
                    x2={414.048}
                    y2={286.75}
                    xlinkHref="#microservices__prefix__c"
                />
                <linearGradient
                    id="microservices__prefix__m"
                    x1={243.437}
                    y1={345.425}
                    x2={307.837}
                    y2={345.425}
                    xlinkHref="#microservices__prefix__a"
                />
                <linearGradient
                    id="microservices__prefix__n"
                    x1={275.427}
                    y1={374.888}
                    x2={307.837}
                    y2={374.888}
                    xlinkHref="#microservices__prefix__b"
                />
                <linearGradient
                    id="microservices__prefix__o"
                    x1={243.122}
                    y1={374.888}
                    x2={275.742}
                    y2={374.888}
                    xlinkHref="#microservices__prefix__c"
                />
                <linearGradient
                    id="microservices__prefix__p"
                    x1={243.437}
                    y1={27.566}
                    x2={307.837}
                    y2={27.566}
                    xlinkHref="#microservices__prefix__a"
                />
                <linearGradient
                    id="microservices__prefix__q"
                    x1={275.427}
                    y1={57.029}
                    x2={307.837}
                    y2={57.029}
                    xlinkHref="#microservices__prefix__b"
                />
                <linearGradient
                    id="microservices__prefix__r"
                    x1={243.122}
                    y1={57.029}
                    x2={275.742}
                    y2={57.029}
                    xlinkHref="#microservices__prefix__c"
                />
                <linearGradient
                    id="microservices__prefix__s"
                    x1={107.446}
                    y1={257.288}
                    x2={171.846}
                    y2={257.288}
                    xlinkHref="#microservices__prefix__a"
                />
                <linearGradient
                    id="microservices__prefix__t"
                    x1={139.436}
                    y1={286.75}
                    x2={171.846}
                    y2={286.75}
                    xlinkHref="#microservices__prefix__b"
                />
                <linearGradient
                    id="microservices__prefix__u"
                    x1={107.131}
                    y1={286.75}
                    x2={139.751}
                    y2={286.75}
                    xlinkHref="#microservices__prefix__c"
                />
            </defs>
            <g data-name="Layer 4">
                <path d="M177.465 258.223l.069-3.152-1.318-.862 34.844-10.844-.054 2.937 1.303 1.077-34.844 10.844zM175.446 157.352l1.329-1.08.021-3.508 34.743 13.433-1.283 1.316-.067 3.273-34.743-13.434zM340.052 246.326l1.325-1.218-.111-3.941 34.879 13.534-1.135 1.435-.08 3.725-34.878-13.535zM272.971 92.946l2.839 1.267 2.551-1.256-.13 36.082-2.466-1.088-2.924 1.076.13-36.081zM272.985 284.19l2.839 1.267 2.551-1.255-.13 36.081-2.835-1.08-2.554 1.069.129-36.082zM340.91 172.719l.008-3.879-1.336-1.236 34.764-14.737.001 3.699 1.328 1.417-34.765 14.736z" />
                <g
                    style={{
                        isolation: "isolate",
                    }}
                >
                    <path
                        fill="url(#microservices__prefix__a)"
                        d="M334.632 169.881l-58.576 34.041-58.959-34.04 58.575-34.041 58.96 34.04z"
                    />
                    <path
                        fill="url(#microservices__prefix__b)"
                        d="M334.632 169.881l-.577 73.503-58.576 34.04.577-73.502 58.576-34.041z"
                    />
                    <path
                        fill="url(#microservices__prefix__c)"
                        d="M276.056 203.922l-.577 73.502-58.959-34.04.577-73.502 58.959 34.04z"
                    />
                </g>
                <g
                    style={{
                        isolation: "isolate",
                    }}
                >
                    <path
                        fill="url(#microservices__prefix__d)"
                        d="M445.082 113.539l-32.095 18.652-32.305-18.652 32.095-18.651 32.305 18.651z"
                    />
                    <path
                        fill="url(#microservices__prefix__e)"
                        d="M445.082 113.539l-.316 40.274-32.095 18.652.316-40.274 32.095-18.652z"
                    />
                    <path
                        fill="url(#microservices__prefix__f)"
                        d="M412.987 132.191l-.316 40.274-32.305-18.652.316-40.274 32.305 18.652z"
                    />
                </g>
                <g
                    style={{
                        isolation: "isolate",
                    }}
                >
                    <path
                        fill="url(#microservices__prefix__g)"
                        d="M170.786 113.539l-32.095 18.652-32.305-18.652 32.095-18.651 32.305 18.651z"
                    />
                    <path
                        fill="url(#microservices__prefix__h)"
                        d="M170.786 113.539l-.316 40.274-32.095 18.652.316-40.274 32.095-18.652z"
                    />
                    <path
                        fill="url(#microservices__prefix__i)"
                        d="M138.691 132.191l-.316 40.274-32.305-18.652.316-40.274 32.305 18.652z"
                    />
                </g>
                <g
                    style={{
                        isolation: "isolate",
                    }}
                >
                    <path
                        fill="url(#microservices__prefix__j)"
                        d="M446.143 257.287l-32.095 18.652-32.305-18.651 32.095-18.652 32.305 18.651z"
                    />
                    <path
                        fill="url(#microservices__prefix__k)"
                        d="M446.143 257.287l-.316 40.274-32.095 18.652.316-40.274 32.095-18.652z"
                    />
                    <path
                        fill="url(#microservices__prefix__l)"
                        d="M414.048 275.939l-.316 40.274-32.305-18.651.316-40.274 32.305 18.651z"
                    />
                </g>
                <g
                    style={{
                        isolation: "isolate",
                    }}
                >
                    <path
                        fill="url(#microservices__prefix__m)"
                        d="M307.837 345.425l-32.095 18.652-32.305-18.651 32.095-18.652 32.305 18.651z"
                    />
                    <path
                        fill="url(#microservices__prefix__n)"
                        d="M307.837 345.425l-.315 40.274-32.095 18.652.315-40.274 32.095-18.652z"
                    />
                    <path
                        fill="url(#microservices__prefix__o)"
                        d="M275.742 364.077l-.315 40.274-32.305-18.652.315-40.273 32.305 18.651z"
                    />
                </g>
                <g
                    style={{
                        isolation: "isolate",
                    }}
                >
                    <path
                        fill="url(#microservices__prefix__p)"
                        d="M307.837 27.566l-32.095 18.652-32.305-18.652 32.095-18.651 32.305 18.651z"
                    />
                    <path
                        fill="url(#microservices__prefix__q)"
                        d="M307.837 27.566l-.315 40.274-32.095 18.652.315-40.274 32.095-18.652z"
                    />
                    <path
                        fill="url(#microservices__prefix__r)"
                        d="M275.742 46.218l-.315 40.274-32.305-18.652.315-40.274 32.305 18.652z"
                    />
                </g>
                <g
                    style={{
                        isolation: "isolate",
                    }}
                >
                    <path
                        fill="url(#microservices__prefix__s)"
                        d="M171.846 257.287l-32.095 18.652-32.305-18.651 32.095-18.652 32.305 18.651z"
                    />
                    <path
                        fill="url(#microservices__prefix__t)"
                        d="M171.846 257.287l-.315 40.274-32.095 18.652.315-40.274 32.095-18.652z"
                    />
                    <path
                        fill="url(#microservices__prefix__u)"
                        d="M139.751 275.939l-.315 40.274-32.305-18.651.315-40.274 32.305 18.651z"
                    />
                </g>
                <text
                    transform="translate(30 458.779)"
                    fontSize={75}
                    fill="#326de6"
                    fontFamily="CenturyGothic-Bold,Century Gothic"
                    fontWeight={700}
                >
                    <tspan>{"Microservices"}</tspan>
                    <tspan x={27.804} y={69.511}>
                        {"Architecture"}
                    </tspan>
                </text>
            </g>
        </svg>
    );
}

export default Microservices;